import { environment } from 'src/environments/environment';

const URL_GATEWAY_QA = 'https://wsqa.polpaicoconexion.cl/api/transportista';
const URL_GATEWAY_PROD = 'https://ws.polpaicoconexion.cl/api/transportista';

/** Base URL del API Gateway transportista según el build (QA vs producción). */
export function getTransportistaGatewayBaseUrl(): string {
  return environment.production ? URL_GATEWAY_PROD : URL_GATEWAY_QA;
}

/**
 * Concatena la base del gateway con una ruta relativa (con o sin slash inicial).
 */
export function gatewayUrl(path: string): string {
  const base = getTransportistaGatewayBaseUrl().replace(/\/$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
}
